import { MARQUEE_ITEMS } from "@/lib/data";

export const Marquee = () => (
  <div className="overflow-hidden border-y border-white/10 bg-azure py-5" data-testid="marquee">
    <div className="flex w-max animate-marquee">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex shrink-0 items-center" aria-hidden={copy === 1}>
          {MARQUEE_ITEMS.map((item) => (
            <span key={item} className="flex items-center gap-8 whitespace-nowrap px-6 font-display text-2xl italic text-sand-50 md:text-4xl">
              {item}
              <span className="text-lg not-italic text-gold">✦</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
